import { Input } from "@/components/ui/input";
import { Section, YesNo } from "@/components/wizard/controls";

export const CustomQuestions = ({ questions, step, f, set }) => {
  const list = questions.filter((q) => q.step === step);
  if (!list.length) return null;
  const update = (id, patch) => set("custom_answers", { ...f.custom_answers, [id]: { ...f.custom_answers[id], ...patch } });
  return (
    <Section title="Additional questions" hint="Set by the Lead Assessor." testId={`custom-questions-${step}`}>
      {list.map((q) => {
        const a = f.custom_answers[q.id] || {};
        return (
          <div key={q.id} className="space-y-2" data-testid={`custom-q-${q.id}`}>
            <div className="flex items-start justify-between gap-3">
              <span className="text-sm font-semibold">{q.label}</span>
              {q.mandatory && <span className="shrink-0 rounded bg-primary/15 px-1.5 py-0.5 text-[10px] font-bold uppercase text-primary">Required</span>}
            </div>
            {q.help && <p className="text-xs text-muted-foreground">{q.help}</p>}
            {q.kind === "yes_no" ? (
              <YesNo value={a.answer === "yes" ? true : a.answer === "no" ? false : null} onChange={(v) => update(q.id, { answer: v ? "yes" : "no" })} testId={`custom-q-${q.id}`} danger="none" />
            ) : (
              <Input className="h-12" value={a.text || ""} onChange={(e) => update(q.id, { text: e.target.value })} data-testid={`custom-q-${q.id}-text`} />
            )}
          </div>
        );
      })}
    </Section>
  );
};

export const missingQuestions = (questions, step, answers) =>
  questions.filter((q) => q.step === step && q.mandatory && (q.kind === "yes_no" ? !answers[q.id]?.answer : !answers[q.id]?.text?.trim()));
